export default __webpack_public_path__ + "static/media/mint.b9763f7a.png";